import axios from 'axios';

const state = {
  notes: {
    items: [],
    loading: false,
  },
};

const getters = {
  notes: (state) => state.notes.items,
  notesLoading: (state) => state.notes.loading,
};

const ENTITY_TYPE_MAP = {
  lead: 'INSURANCE_LEAD',
  policy: 'INSURANCE_POLICY',
  request: 'TICKET',
  insured: 'PERSON_PROFILE',
  personalDeal: 'PERSONAL_DEAL',
};

const actions = {
  async fetchNotes({ commit }, { entityType, entityId }) {
    commit('setNotesLoading', true);
    try {
      const type = ENTITY_TYPE_MAP[entityType] || entityType;
      const response = await axios.post('/insurance/note/list', {
        entityType: type,
        entityId,
      });
      commit('setNotes', response.data.items || []);
      return response.data.items;
    } catch (error) {
      console.error('Error fetching notes:', error);
      throw error;
    } finally {
      commit('setNotesLoading', false);
    }
  },
  async addNote({ commit, rootGetters }, { entityType, entityId, text }) {
    const user = rootGetters.user || {};
    const tempId = `temp-${Date.now()}`;
    const tempNote = {
      id: tempId,
      text,
      authorUserId: user.id,
      authorName: user?.name || user?.email,
      entityType,
      entityId,
      created: new Date().toISOString(),
      updated: new Date().toISOString(),
      isEdited: false,
      isTemp: true,
    };

    commit('addNote', tempNote);

    try {
      const type = ENTITY_TYPE_MAP[entityType] || entityType;
      const response = await axios.post('/insurance/note/save', {
        entityType: type,
        entityId,
        text,
      });
      // We use addNote here because updateNote with oldId will replace the temp one
      commit('updateNote', { oldId: tempId, newNote: response.data });
      return response.data;
    } catch (error) {
      commit('deleteNote', tempId);
      console.error('Error adding note:', error);
      throw error;
    }
  },
  async updateNote({ commit, state }, { noteId, text }) {
    const originalNote = state.notes.items.find((n) => n.id === noteId);
    if (!originalNote) return null;

    const updatedNote = {
      ...originalNote, text, isEdited: true
    };
    commit('updateNote', { newNote: updatedNote });

    try {
      const response = await axios.post('/insurance/note/save', {
        noteId,
        text,
      });
      commit('updateNote', { newNote: response.data });
      return response.data;
    } catch (error) {
      commit('updateNote', { newNote: originalNote });
      console.error('Error updating note:', error);
      throw error;
    }
  },
  async deleteNote({ commit, state }, noteId) {
    const originalNote = state.notes.items.find((n) => n.id === noteId);
    if (!originalNote) return;

    commit('deleteNote', noteId);

    try {
      await axios.post('/insurance/note/delete', { noteId });
    } catch (error) {
      commit('addNote', originalNote);
      console.error('Error deleting note:', error);
      throw error;
    }
  },
};

const mutations = {
  setNotesLoading(state, loading) {
    state.notes.loading = loading;
  },
  setNotes(state, notes) {
    state.notes.items = notes;
  },
  addNote(state, note) {
    state.notes.items.push(note);
  },
  updateNote(state, { oldId, newNote }) {
    const idToFind = oldId || newNote.id;
    const index = state.notes.items.findIndex((n) => n.id === idToFind);
    if (index !== -1) {
      state.notes.items.splice(index, 1, newNote);
    }
  },
  deleteNote(state, noteId) {
    state.notes.items = state.notes.items.filter((n) => n.id !== noteId);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
